import { useEffect, useState } from 'react'

import ServerlessApi from 'services/ServerlessApi'

const useServerlessDealerFeatures = (dealerId: string | string) => {
  const [features, setFeatures] = useState<Array<string>>([])
  const [isFeaturesLoaded, setIsFeaturesLoaded] = useState(false)

  useEffect(() => {
    setIsFeaturesLoaded(false)

    ServerlessApi.Features.getDealerBetaFeature(dealerId)
      .then((res: { dealerBetaFeatures: string[] }) => {
        setFeatures(res.dealerBetaFeatures)
      }).catch(() => {
        setFeatures([])
      })
      .finally(() => setIsFeaturesLoaded(true))
  }, [dealerId])

  return { features, isFeaturesLoaded }
}

export default useServerlessDealerFeatures
